const VoucherProductPromotionType = {
  PRICE: 1,
  PERCENT: 2
}
export default VoucherProductPromotionType
